import { useEffect } from 'react';
import env from '~env';
import logger from '~logger';

const globalPageUrl = env.publicUrls.globalPage;

export const useRedirectToNewDomain = () => {
  useEffect(() => {
    const isIframe = window.top !== window.self;
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const accountName = pathSegments[1]; // Assuming the URL structure is /global-page/accountName
    const newUrl = accountName
      ? `${globalPageUrl}/#/account/${accountName}`
      : `${globalPageUrl}/`;

    logger.info(
      `The page https://platform.nizza.com/global-page has been replaced by a new domain, please use the new domain: ${newUrl}`,
    );

    if (!isIframe) {
      window.location.replace(newUrl);
    } else {
      window.location.href = newUrl;
    }
  }, []);
};
